import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()

export class StaticPageService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.staticPage.listUrl, ServiceConfig.staticPage.detailUrl);
  }
}



// WEBPACK FOOTER //
// ./src/services/static-page.service.ts